"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DonutChart = require("./DonutChart");
Object.keys(_DonutChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DonutChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DonutChart[key];
    }
  });
});